// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__BHjL4","Label":"Input_Label__36GBw","InputElement":"Input_InputElement__t70LU","Invalid":"Input_Invalid__XWBn1"};